import { defineMessages } from 'react-intl';

export const messages: {
	quarterPickerButtonMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	monthPickerButtonMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dayPickerButtonMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	intervalPickerButtonMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	intervalOptionAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	quarterPickerButtonMessage: {
		id: 'date-range-picker.date-range-picker-content.quarter-picker-button-message',
		defaultMessage: 'Quarter',
		description: 'Button message for selecting quarter view of the calendar',
	},
	monthPickerButtonMessage: {
		id: 'date-range-picker.date-range-picker-content.month-picker-button-message',
		defaultMessage: 'Month',
		description: 'Button message for selecting month view of the calendar',
	},
	dayPickerButtonMessage: {
		id: 'date-range-picker.date-range-picker-content.day-picker-button-message',
		defaultMessage: 'Day',
		description: 'Button message for selecting day view of the calendar',
	},
	intervalPickerButtonMessage: {
		id: 'date-range-picker.date-range-picker-content.interval-picker-button-message',
		defaultMessage: 'Interval',
		description: 'Button message for selecting interval view of the calendar',
	},
	intervalOptionAriaLabel: {
		id: 'date-range-picker.date-range-picker-content.interval-option-aria-label',
		defaultMessage: '{name}, {dateRange}',
		description: 'Accessible label for an interval option (name and date range)',
	},
});
